import PageHero from './PageHero';

export default PageHero;
